import React, { forwardRef, useState } from "react"
import { Card, Col, Dropdown, Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Settings from "../../../common/Settings"
import moment from "moment"
import { parsedUser } from "../../../common/GetCurrentUser"
import FlagsModal from "../../Record/FlagsModal"
import AdminContainerModal from "../../Admin/AdminContainerModal"
import { resolvePhotoSrc, PHOTO_FALLBACK } from "../../../common/photoSource"

const QuickAddToggle = forwardRef<HTMLButtonElement, { onClick?: (e: any) => void }>(
  ({ onClick }, ref) => (
    <button
      ref={ref}
      type="button"
      className="btn btn-info btn-sm"
      title="Agregar registro rápido"
      onClick={e => {
        e.preventDefault()
        onClick && onClick(e)
      }}
    >
      <i className="fa fa-plus"></i>
    </button>
  )
)

const VerificarAntecedentesListView = (props: {
  records: any[]
  admin?: boolean
  isLoading?: boolean
  backgroundCheck?: boolean
}) => {
  const records = props.records
  const { t } = useTranslation("global")
  const [showPublicFunctionaryModal, setShowPublicFunctionaryModal] = useState(false)
  const [selectedReference, setSelectedReference] = useState("")
  const user = parsedUser()
  const handleOpenPublicFunctionaryModal = (reference: string) => {
    setSelectedReference(reference)
    setShowPublicFunctionaryModal(true)
  }
  const [showFlags, setShowFlags] = useState(false)
  const [itemId, setItemId] = useState("")
  const [quickAdminConfig, setQuickAdminConfig] = useState<{
    initialSection: "fichados" | "deportados" | "desaparecidos" | "extraditados"
    title: string
    prefillIdentifier: string
  } | null>(null)
  const handleClosePublicFunctionaryModal = () => {
    setShowPublicFunctionaryModal(false)
    setSelectedReference("")
  }
  return (
    <Col xs={12}>
      <Card className="mb-4">
        <Card.Body className="p-0 ">
          <div className="table-responsive">
            {records && records.length > 0 ? (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th></th>
                    <th>{t("Datos Generales")}</th>
                    <th>{t("Clasificación")}</th>
                    <th className="text-center">{t("Recomendaciones")}</th>
                    <th className="text-center"></th>
                  </tr>
                </thead>
                <tbody>
                  {records &&
                    records.map((record: any, index: number) => {
                      const hasFichas = (record.fichas ?? 0) > 0
                      const hasAudiencias = (record.audiencias?.total ?? 0) > 0
                      const hasSentencias = (record.sentencias?.total ?? 0) > 0
                      const hasJudicialSignals = !!record.fichado || hasFichas || hasAudiencias || hasSentencias

                      if (record.type === "persona") {//persona
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>
                                {resolvePhotoSrc(record) && (
                                  <img
                                    onError={(e: any) => {

                                      if (
                                        e.target.src !== PHOTO_FALLBACK
                                      ) {
                                        e.target.src = PHOTO_FALLBACK
                                      }
                                    }}
                                    src={resolvePhotoSrc(record) ?? PHOTO_FALLBACK}
                                    style={{
                                      minHeight: "100px",
                                      minWidth: "100px",
                                      maxWidth: "200px",
                                      maxHeight: "200px",
                                      objectFit: "cover",
                                      height: "100px",
                                      width: "100px",
                                    }}
                                    className="img-fluid img-thumbnail my-2"
                                    alt=""
                                  />
                                )}
                              </td>

                              <td>
                                <b className="me-2">{t("Name")}:</b>
                                {`${record.nombres ?? ""} ${record.apellido1 ?? ""
                                  } ${record.apellido2 ?? ""}`}
                                <br />
                                <b className="me-2">Cédula</b>
                                {record.cedula}
                                <br />
                                <b className="me-2">{t("Fecha de Nacimiento")}</b>
                                {record.fechaNacimiento &&
                                  moment(
                                    record.fechaNacimiento.substring(0, 10)
                                  ).format("DD/MM/YYYY")}
                                <br />
                                {record.alias && <>
                                  <b className="me-2">{t("Alias")}</b>
                                  {record.alias}
                                  <br />
                                </>}
                                <b className="me-2">{t("Género")}</b>
                                {record.sexo === "M" ? "Masculino" : "Femenino"}
                                <br />
                                <b className="me-2">{t("Edad")}</b>
                                {record.edad ? Math.round(record.edad) : 0}
                              </td>
                              <td>
                                {record.banderas?.pip ? <div className="mb-1"><span className="badge bg-danger text-white" title="Persona Imputada Penalmente">PIP</span></div> : ""}
                                {record.banderas?.padep ? <div className="mb-1"><span className="badge bg-danger text-white" title="Persona Asociada a un Delito Precedente">PADEP</span></div> : ""}
                                {record.banderas?.rasadep ? <div className="mb-1"><span className="badge bg-danger text-white" title="Razón Social Asociada a un Delito Precedente">RASADEP</span></div> : ""}
                                {record.banderas?.pecop ? <div className="mb-1"><span className="badge bg-dark text-white" title="Condenado PECOP">PECOP</span></div> : ""}
                                {record.banderas?.empleadopublico ? <div className="mb-1"><span className="badge bg-info text-white">Empleado Público</span></div> : ""}
                                {record.banderas?.empleadoprivado ? <div className="mb-1"><span className="badge bg-info text-white">Empleado Privado</span></div> : ""}
                                {record.banderas?.fallecido ? <div className="mb-1"><span className="badge text-white" style={{ backgroundColor: "#000" }}>Fallecido</span></div> : ""}
                                {record.padep ? <div className="mb-1"><span className="badge bg-danger text-white" title="Persona Asociada a un Delito Precedente">PADEP</span></div> : ""}
                                {record.publicFunctionary === true && (
                                  <div className="mb-1">
                                    <span
                                      className="badge bg-primary clickable"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => handleOpenPublicFunctionaryModal(record.cedula || '')}
                                      title="Persona Expuesta Públicamente - Click para ver referencia"
                                    >
                                      PEP
                                    </span>
                                  </div>
                                )}
                              </td>

                              <td className="text-center">
                                {!hasJudicialSignals && (
                                  <div className="mb-1">
                                    <span
                                      className="badge bg-success"
                                      title={"No antencedentes judiciales"}
                                    >
                                      <i className="fa fa-check me-2"></i>
                                      No antencedentes judiciales
                                    </span>
                                  </div>
                                )}
                                {record.extraditado && (
                                  <div className="mb-1">
                                    <span
                                      className="badge "
                                      style={{ backgroundColor: "blue" }}
                                      title={
                                        "Solicitar certificado de no extradicción"
                                      }
                                    >
                                      <i className="fa fa-exclamation-triangle me-2"></i>
                                      Solicitar certificado de no extradicción
                                    </span>
                                  </div>
                                )}
                                {(hasFichas || hasSentencias) && (
                                  <div className="mb-1">
                                    <span
                                      className="badge bg-danger"
                                      title={
                                        "Solicitar certificado de no antecedentes judiciales"
                                      }
                                    >
                                      <i className="fa fa-exclamation-triangle me-2"></i> Solicitar certificado de no antecedentes
                                      judiciales
                                    </span>
                                  </div>
                                )}
                                {record.desaparecido && (
                                  <div className="mb-1">
                                    <div
                                      className="badge bg-warning  text-wrap"
                                      title={
                                        "Desaparecid@"
                                      }
                                    >
                                      <i className="fa fa-exclamation-triangle"></i>
                                      <span className="ms-2">
                                        Desaparecid@
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {record.deportado && record.deportado === true && (
                                  <div className="mb-1">
                                    <span
                                      className="badge "
                                      style={{ backgroundColor: "purple" }}
                                      title={
                                        "Deportado"
                                      }
                                    >
                                      <i className="fa fa-exclamation-triangle me-2"></i>
                                      Solicitar Certificado de no Deportación
                                    </span>
                                  </div>
                                )}
                                <div className="mb-1">
                                  <div
                                    className="badge bg-warning  text-wrap"
                                    title={"No casos laborales"}
                                  >
                                    <i className="fa fa-check"></i>
                                    <span className="ms-2">No casos laborales</span>
                                  </div>
                                </div>

                              </td>
                              <td className="text-end">
                                <button className="btn btn-secondary mt-2"
                                  onClick={() => {
                                    window.open(
                                      `bcr/${record.cedula}`,
                                      "_blank"
                                    )
                                  }}
                                >
                                  <i className="fa fa-file"></i> {t("Ver Reporte")}
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={5} >
                                <div className="row">
                                  <div className="col-6">


                                    {user && user.RoleId === "admin" && (
                                      <Dropdown className=" d-inline-block  me-2">
                                        <Dropdown.Toggle as={QuickAddToggle} />
                                        <Dropdown.Menu>
                                          <Dropdown.Item onClick={() => setQuickAdminConfig({ initialSection: "fichados", title: "Nuevo Registro", prefillIdentifier: record.cedula })}>
                                            Registros
                                          </Dropdown.Item>
                                          <Dropdown.Item onClick={() => setQuickAdminConfig({ initialSection: "deportados", title: "Nuevo Deportado", prefillIdentifier: record.cedula })}>
                                            Deportados
                                          </Dropdown.Item>
                                          <Dropdown.Item onClick={() => setQuickAdminConfig({ initialSection: "desaparecidos", title: "Nuevo Desaparecido", prefillIdentifier: record.cedula })}>
                                            Desaparecidos
                                          </Dropdown.Item>
                                          <Dropdown.Item onClick={() => setQuickAdminConfig({ initialSection: "extraditados", title: "Nuevo Extraditado", prefillIdentifier: record.cedula })}>
                                            Extraditados
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    )}
                                    {user && user.RoleId === "admin" && (<button
                                      onClick={() => {
                                        setItemId(record.cedula)
                                        setShowFlags(true)
                                      }}
                                      className="btn btn-primary btn-sm d-inline-block">
                                      <i className="fa fa-flag"></i>
                                    </button>)}
                                  </div>
                                  <div className="col-6 text-end">
                                    {(hasAudiencias || hasFichas) && (
                                      <span className="badge bg-warning text-black me-2  py-2 px-4  ">
                                        <i className="fa fa-gavel mx-2"></i>
                                        {t("Procesos")}
                                      </span>
                                    )}
                                    {hasSentencias && (
                                      <span className="badge bg-info py-2 px-4 text-white me-2 ">
                                        <i className="fa fa-scale-balanced mx-2"></i>
                                        {t("Sentencias")}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        )
                      } else {// rnc
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>

                              </td>

                              <td>
                                <b className="me-2">{t("Name")}:</b>
                                {`${record.razonSocial ?? ""} `}
                                <br />
                                <b className="me-2">RNC</b>
                                {record.rnc}

                              </td>
                              <td>
                                {record.empresaComprometida ? <p> <span className="badge bg-danger text-white">RASADEP</span></p> : <p> <span className="badge bg-success text-white" title="Razón Social Sin Hallazgos de Oponibilidad">RASSHAOP</span></p>}

                              </td>

                              <td className="text-center">



                              </td>
                              <td className="text-end">
                                <button className="btn btn-secondary mt-2"
                                  onClick={() => {
                                    window.open(
                                      `bcr/${record.rnc}`,
                                      "_blank"
                                    )
                                  }}
                                >
                                  <i className="fa fa-file"></i> {t("Ver Reporte")}
                                </button>
                              </td>
                            </tr>
                          </React.Fragment>
                        )
                      }


                    })}

                  {records.length === 0 ? (
                    <tr>
                      <td colSpan={6} className="text-center">
                        {t("No Results")}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            ) : (
              <div className="text-center py-2">
                <h3>{t("No records found")}</h3>
              </div>
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showPublicFunctionaryModal}
        onHide={handleClosePublicFunctionaryModal}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Referencia - Funcionario Público")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReference && (
            <iframe
              src={`${Settings.BasePath}api/Busqueda/FunctionaryProfile/${selectedReference}`}
              style={{
                width: '100%',
                height: '600px',
                border: 'none'
              }}
              title="Referencia Funcionario Público"
            />
          )}
          {!selectedReference && (
            <div className="text-center py-4">
              <p>{t("No reference available")}</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
      {showFlags && <FlagsModal
        show={showFlags}
        identificador={itemId}
        onClose={() => setShowFlags(false)}
      />}
      {quickAdminConfig && (
        <AdminContainerModal
          toggle={() => setQuickAdminConfig(null)}
          title={quickAdminConfig.title}
          initialSection={quickAdminConfig.initialSection}
          autoOpenCreate={true}
          prefillIdentifier={quickAdminConfig.prefillIdentifier}
        />
      )}
    </Col>
  )
}

export default VerificarAntecedentesListView
